var _rect, _path, _g, _path2, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDevice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 40,
    viewBox: "0 0 36 40",
    width: 36,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    height: 20,
    rx: 1,
    stroke: "#4ee39d",
    transform: "matrix(0 1 -1 0 61 -8)",
    width: 3,
    x: 34.5,
    y: 26.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.5 26.5h5",
    stroke: "#4ee39d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4ee39d"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m34 11.5v12c0 .2761-.2239.5-.5.5h-18c-.2761 0-.5-.2239-.5-.5v-.8152c-.3134.1811-.6525.3009-1 .3593v.4559c0 .8284.6716 1.5 1.5 1.5h18c.8284 0 1.5-.6716 1.5-1.5v-12c0-.8284-.6716-1.5-1.5-1.5h-18c-.8284 0-1.5.6716-1.5 1.5v6.6717l1-1v-5.6717c0-.2761.2239-.5.5-.5h18c.2761 0 .5.2239.5.5z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 17.3152v-2.8152c0-.8284-.6716-1.5-1.5-1.5h-7c-.82843 0-1.5.6716-1.5 1.5v14c0 .8284.67157 1.5 1.5 1.5h7c.8284 0 1.5-.6716 1.5-1.5v-5.8154c-.2221-.1283-.4312-.2875-.6212-.4775l-.3788-.3788v6.6717c0 .2761-.2239.5-.5.5h-7c-.27614 0-.5-.2239-.5-.5v-14c0-.2761.22386-.5.5-.5h7c.2761 0 .5.2239.5.5v2.4559c.3475.0584.6866.1782 1 .3593z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 9,
    opacity: 0.3,
    rx: 1,
    transform: "matrix(0 1 -1 0 25 2)",
    width: 16,
    x: 11.5,
    y: 13.5
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m5.5 23.5 4.29289-4.2929c.39051-.3905 1.02371-.3905 1.41421 0l1.5858 1.5858c.3905.3905 1.0237.3905 1.4142 0l3.2929-3.2929 1.2929-1.2929c.3905-.3905 1.0237-.3905 1.4142 0l2.5858 2.5858c.3905.3905 1.0237.3905 1.4142 0l4.7929-4.7929m0 0h-2.5m2.5 0v2.5",
    stroke: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#4ee39d",
    height: 20,
    opacity: 0.3,
    rx: 1,
    transform: "matrix(0 1 -1 0 61 -8)",
    width: 3,
    x: 34.5,
    y: 26.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDevice);
export default __webpack_public_path__ + "static/media/Icon-Device.1d2b39f3d7cccf6c9b088b484306ee9c.svg";
export { ForwardRef as ReactComponent };